import React from 'react'
import classnames from 'classnames/bind'
import InfiniteScroll from 'react-infinite-scroller'
import { isNull } from 'lodash-es'

// Libs
import { useThemeProductList } from '@/components/pages/Mall/hooks/useThemeProductList'
import { handleGtmViewItemList } from '@/methods/handleGtmEvent'
import { useObserver } from '@/hooks/useObserver'
// import useMedia from '@/hooks/useMedia'

// Components
import ProductCard from '@/components/shared/ProductCard'
import ThemeGoBackButton from '@/components/pages/Mall/components/ThemeGoBackButton'

// constants
import { ProductInfoType } from '@/api/fetchProductData'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

interface ThemeProductListProps {
  themeId: any
  themeGoBackData: any
  gtmItemEventParams: {
    itemListName: string
    itemListId?: string
  }
}

const ThemeProductList = (props: ThemeProductListProps) => {
  const { themeId, themeGoBackData, gtmItemEventParams } = props

  const themeProductListData = useThemeProductList(themeId, {})
  const themeProductList = themeProductListData?.data?.pages
    .map((item: { productsInfo: ProductInfoType[] }) => item.productsInfo)
    .flat()
    .filter((rowItem: any) => !isNull(rowItem))

  const handleNextpage = () => {
    if (!themeProductListData.isFetchingNextPage) {
      themeProductListData.fetchNextPage()
    }
  }

  const isIntersecCb = (entries: IntersectionObserverEntry[]) => {
    const isIntersectingEntries = entries.filter((entry: IntersectionObserverEntry) => entry.isIntersecting)
    const dataAttributes = isIntersectingEntries.map((entry) => (entry.target as any).dataset)
    const productIdList = dataAttributes.map((item) => Number(item.id))
    if (productIdList.length > 0 && themeProductList) {
      const intersectingProductList = themeProductList.filter((productItem: ProductInfoType) => productIdList.includes(productItem.productId))
      handleGtmViewItemList({ ...gtmItemEventParams, productInfoList: intersectingProductList })
    }
  }

  const { observerRef } = useObserver({ observerCallback: isIntersecCb, dep: [themeProductListData] })
  return (
    <div className={cx('theme-product-list')}>
      <InfiniteScroll className={cx('theme-product-list__list')} loadMore={handleNextpage} hasMore={themeProductListData?.hasNextPage}>
        {themeProductListData?.isSuccess &&
          themeProductListData?.data?.pages.length > 0 &&
          themeProductListData?.data?.pages.map((item: any, pageIndex: number) => (
            <React.Fragment key={pageIndex}>
              {pageIndex === 0 && <ThemeGoBackButton {...themeGoBackData} />}
              {item?.productsInfo?.map((item: any) => (
                <ProductCard key={item.productId} {...item} observer={observerRef.current} gtmItemEventParams={gtmItemEventParams} />
              ))}
            </React.Fragment>
          ))}
      </InfiniteScroll>
    </div>
  )
}

export default React.memo(ThemeProductList)
